import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const ChoseArea = () => {
  const { t } = useTranslation();
  return (
    <>
      <section className="tp-choose-area position-relative pt-120 pb-90">
        <div className="tp-choose-yellow-bg"></div>
        <div className="container" id="hireUs">
          <div className="row justify-content-between">
            <div className="col-xl-6 col-lg-8">
              <div className="tp-choose z-index">
                <div
                  className="tp-section-title-wrapper mb-105 wow fadeInUp"
                  data-wow-delay=".2s"
                >
                  <h5 className="tp-section-subtitle common-yellow-shape common-white-shape section__sm__title">
                    {t("ChoseArea.WhyHireUs")}
                  </h5>
                  <h2 className="tp-section-title">
                    {t("ChoseArea.ExpertHouse")}
                  </h2>
                </div>
                <div className="tp-choose-img mb-40 z-index d-block d-xl-none">
                  <img
                    src="assets/img/about/choose-img-1.jpg"
                    alt="img not found"
                  />
                </div>
                <div className="row">
                  <div className="col-sm-6">
                    <div className="tp-choose-timeline ml-15 mb-30">
                      <div
                        className="tp-choose-timeline-single mb-55 pl-35 wow fadeInUp"
                        data-wow-delay=".4s"
                      >
                        <h4 className="tp-choose-timeline-single-title mb-15 hover-theme-color">
                          <Link to="/servicesDetails">
                            {t("ChoseArea.EveryCustomer")}
                          </Link>
                        </h4>
                        {t("ChoseArea.EveryCustomerText")}
                      </div>
                      <div
                        className="tp-choose-timeline-single mb-55 pl-35 wow fadeInUp"
                        data-wow-delay=".6s"
                      >
                        <h4 className="tp-choose-timeline-single-title mb-15 hover-theme-color">
                          <Link to="/servicesDetails">
                            {t("ChoseArea.Quality")}
                          </Link>
                        </h4>
                        {t("ChoseArea.QualityText")}{" "}
                      </div>
                      <div
                        className="tp-choose-timeline-single pl-35 wow fadeInUp"
                        data-wow-delay=".8s"
                      >
                        <h4 className="tp-choose-timeline-single-title mb-15 hover-theme-color">
                          <Link to="/servicesDetails">
                            {t("ChoseArea.satisfaction")}
                          </Link>
                        </h4>
                        {t("ChoseArea.setisfactionText")}
                      </div>
                    </div>
                  </div>
                  <div className="col-sm-6">
                    <div className="tp-choose-timeline ml-15 mb-30">
                      <div
                        className="tp-choose-timeline-single mb-55 pl-35 wow fadeInUp"
                        data-wow-delay="1s"
                      >
                        <h4 className="tp-choose-timeline-single-title mb-15 hover-theme-color">
                          <Link to="/servicesDetails">
                            {t("ChoseArea.BookAppointment")}
                          </Link>
                        </h4>
                        {t("ChoseArea.BookAppointmentText")}{" "}
                      </div>
                      <div
                        className="tp-choose-timeline-single mb-55 pl-35 wow fadeInUp"
                        data-wow-delay="1.2s"
                      >
                        <h4 className="tp-choose-timeline-single-title mb-15 hover-theme-color">
                          <Link to="/servicesDetails">
                            {t("ChoseArea.Trust")}
                          </Link>
                        </h4>
                        {t("ChoseArea.TrustText")}{" "}
                      </div>
                      <div
                        className="tp-choose-timeline-single pl-35 wow fadeInUp"
                        data-wow-delay="1.4s"
                      >
                        <h4 className="tp-choose-timeline-single-title mb-15 hover-theme-color">
                          <Link to="/servicesDetails">
                            {t("ChoseArea.WorryFree")}
                          </Link>
                        </h4>
                        <p>{t("ChoseArea.WorryFreeText")} </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-5 col-12">
              <div
                className="tp-choose-img mb-30 z-index d-none d-xl-block wow fadeInUp"
                data-wow-delay=".6s"
              >
                <img
                  src="assets/img/about/choose-img-1.jpg"
                  alt="img not found"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ChoseArea;
